const nepali_en = {
  name: "nepali_en",
  months: [
    ["Baishakh", "Baishakh"],
    ["Jestha", "Jestha"],
    ["Ashadh", "Ashadh"],
    ["Shrawan", "Shrawan"],
    ["Bhadra", "Bhadra"],
    ["Ashwin", "Ashwin"],
    ["Kartik", "Kartik"],
    ["Mangsir", "Mangsir"],
    ["Poush", "Poush"],
    ["Magh", "Magh"],
    ["Falgun", "Falgun"],
    ["Chaitra", "Chaitra"],
  ],
  weekDays: [
    ["Saturday", "Sat"],
    ["Sunday", "Sun"],
    ["Monday", "Mon"],
    ["Tuesday", "Tue"],
    ["Wednesday", "Wed"],
    ["Thursday", "Thu"],
    ["Friday", "Fri"],
  ],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [
    ["AM", "am"],
    ["PM", "pm"],
  ],
};

export default nepali_en;
